import classnames from "classnames";
import classes from "../../../styles/Resources.module.scss";
import Banner from "../../../components/common/Banner/Banner";
import BannerType from "../../../global/banner-type";
import resources from "../../../assets/images/resources.png";
import { googleRCSdata, faqChannel } from "../../../global/constant";
import ContentSection from "../../../components/common/ContentSection/ContentSection";

const GoogleRCS = () => {
  return (
    <div className={classnames(classes.main_content)}>
      <div className={classnames(classes.bannerSection)}>
        <Banner
          type={BannerType.SINGLE_IMAGE_BANNER}
          title="Google RCS"
          description="RCS is an evolution of SMS (Short Message Service) and provides enhanced features and capabilities, allowing businesses to deliver engaging and dynamic content to users' smartphones."
          image={resources}
          maxWidth={214}
          className={classes.containerWidth}
        />
      </div>
      <ContentSection
        heading="Features and application of Google RCS Channel"
        data={googleRCSdata}
        faqData={faqChannel}
        isIndexingRequired={false}
      />
    </div>
  );
};

export default GoogleRCS;
